import { CommonEnums } from "../../enums/common.enums";
import axiosInstance from "./Axios";

export class AuthApi {
  static getRoles = async () => {
    try {
      const res = await axiosInstance.get(`admin/roles`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static register = async (data: {
    role: string;
    email: string;
    invitation_code: string;
    principal_agent_id?: string;
    invitee_email?: string;
  }) => {
    try {
      let url = "agency/register";

      if (data.role === CommonEnums.roles.agent) url = "agent/register";

      const res = await axiosInstance.post(url, data);

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static EmailVerifyOtp = async (
    data: { otp: string; email: string },
    type: string
  ) => {
    try {
      const res = await axiosInstance.post(`${type}/register/verify-otp`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static emailVerifyOtp = async (data: any) => {
    try {
      const res = await axiosInstance.post(`admin/auth/verify-otp`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static LoginEmailVerifyOtp = async (data: { otp: string }) => {
    try {
      const res = await axiosInstance.post("client/auth/verify-login", data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static EmailResendOtp = async (data: { email: string }, type: string) => {
    try {
      const res = await axiosInstance.post(`${type}/register/resend-otp`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static LoginAgent = async (data: { role: string; email: string }) => {
    try {
      const res = await axiosInstance.post("client/auth/login", data);

      return {
        data: res.data,
      };
    } catch (err: any) {
      // const status = err?.status;

      // if (status === 401) {
      //   window.location.href = clientRoutes.login;
      //   toast.error("Unauthorized, please login!");
      // }
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static verifyPhone = async (data: { user_type: string }) => {
    try {
      let verifyPhoneRoute = "agent/verify-phone";

      if (data.user_type === CommonEnums.roles.agency)
        verifyPhoneRoute = "agency/verify-phone";

      const res = await axiosInstance.post(verifyPhoneRoute);
      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static resendLoginVerificationCode = async () => {
    try {
      const res = await axiosInstance.post(
        `client/auth/login/resend-email-verification`
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static agentProfileAddAgency = async (params: { agency_id: string }) => {
    try {
      const res = await axiosInstance.post(`agent/add-agency`, {
        agency_id: params?.agency_id?.trim(),
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static statusChange = async (api_key: string) => {
    try {
      const res = await axiosInstance.post(api_key);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };
  static deleleAll = async (api_key: string) => {
    try {
      const res = await axiosInstance.delete(api_key);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };
}
